const templateFAQ = () => {
  document.addEventListener("DOMContentLoaded", () => {
    openAccordionFromHash();

    const btns = document.querySelectorAll(".accordion-button");
    btns.forEach((btn) => {
      btn.addEventListener("click", () => smoothScroll(btn));
    });
  });

  window.addEventListener("hashchange", openAccordionFromHash);
};

/**
 * Open accordion from hash
 * 
 * @returns 
 */

const openAccordionFromHash = () => {
  const hash = window.location.hash;
  if (!hash) return;

  const header = document.querySelector(hash);
  if (!header || !header.classList.contains("accordion-header")) return;

  const item = header.closest(".accordion-item");
  if (!item) return;

  const btn = item.querySelector(".accordion-button");
  const collapseId = btn?.getAttribute("data-bs-target");
  const body = document.querySelector(collapseId);

  if (!btn || !body) return;

  // Collapse all others
  document.querySelectorAll(".accordion-button").forEach((b) => {
    b.classList.add("collapsed");
    b.setAttribute("aria-expanded", "false");
  });

  document.querySelectorAll(".accordion-collapse").forEach((c) => {
    c.classList.remove("show");
  });

  // Expand current
  btn.classList.remove("collapsed");
  btn.setAttribute("aria-expanded", "true");
  body.classList.add("show");

  smoothScroll(btn);
};

/**
 * Scroll to accordion 
 * 
 * @param {*} btn 
 */

const smoothScroll = (btn) => {
  setTimeout(() => {
    const headerHeight = document.querySelector(".navbar")?.offsetHeight || 0;
    const top = btn.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: top - headerHeight,
      behavior: "smooth",
    });
  }, 300);
};

export default templateFAQ;
